"use client";
import dynamic from "next/dynamic";
import DeferHydrate from "@/components/defer-hydrate";

// Клиентская обёртка для тяжёлых below-the-fold секций. Здесь (в client-компоненте)
// РАЗРЕШЁН ssr:false, поэтому их HTML не рендерится на сервере и не гидрируется на
// старте — react-slick / fancybox / react-phone-input / framer-motion исполняются
// ТОЛЬКО когда секция подъезжает к вьюпорту (DeferHydrate + IntersectionObserver).
// Это снимает главный поток в окне LCP хироя. Заголовок/описание/schema уже в SSR,
// так что для SEO landing это безопасно (галереи — визуальный контент, не текст).
//
// min-height зарезервирован под каждую секцию, чтобы отложенный монтаж не давал CLS.
const BuildingGallery = dynamic(() => import("@/components/building-gallery"), {
  ssr: false,
});
const FlatGallery = dynamic(() => import("@/components/flat-gallery"), {
  ssr: false,
});
const Gallery = dynamic(() => import("@/components/gallety"), { ssr: false });
const ContactForm = dynamic(
  () => import("@/components/contact").then((m) => m.ContactForm),
  { ssr: false },
);

export function BuildingGallerySection() {
  return (
    <DeferHydrate minHeight={620}>
      <BuildingGallery />
    </DeferHydrate>
  );
}

export function FlatGallerySection() {
  // id на обёртке (не внутри FlatGallery): секция монтируется лениво, а якорь
  // #flat-for-sale (меню «Планировки», hero-CTA, JSON-LD) должен существовать всегда.
  return (
    <DeferHydrate minHeight={620} id="flat-for-sale">
      <FlatGallery />
    </DeferHydrate>
  );
}

export function GallerySection() {
  return (
    <DeferHydrate minHeight={480} id="gallery">
      <Gallery />
    </DeferHydrate>
  );
}

export function ContactFormSection() {
  return (
    <DeferHydrate minHeight={560} id="contacts">
      <ContactForm />
    </DeferHydrate>
  );
}
